module.exports = __webpack_public_path__ + "img/jp2@2x.75ebe4e5.png";